import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonAlignLeft} from 'mui-tiptap';

const StyledEditorMenuButtonAlignLeft = styled(MenuButtonAlignLeft)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonAlignLeft.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonAlignLeft;
